import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_34482ef1 from 'nuxt_plugin_plugin_34482ef1' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_gtm_7a970fc6 from 'nuxt_plugin_gtm_7a970fc6' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_4cc42d2f from 'nuxt_plugin_cookieuniversalnuxt_4cc42d2f' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_554d9194 from 'nuxt_plugin_pluginutils_554d9194' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_239fec42 from 'nuxt_plugin_pluginrouting_239fec42' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_b3057420 from 'nuxt_plugin_pluginmain_b3057420' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_488c7b87 from 'nuxt_plugin_axios_488c7b87' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_helpers_0cfa93b2 from 'nuxt_plugin_helpers_0cfa93b2' // Source: ../plugins/helpers.plugin (mode: 'all')
import nuxt_plugin_services_7e39488d from 'nuxt_plugin_services_7e39488d' // Source: ../plugins/services.plugin (mode: 'all')
import nuxt_plugin_axios_f6f05bbe from 'nuxt_plugin_axios_f6f05bbe' // Source: ../plugins/axios.plugin (mode: 'all')
import nuxt_plugin_vmask_775c71e8 from 'nuxt_plugin_vmask_775c71e8' // Source: ../plugins/v-mask.plugin (mode: 'all')
import nuxt_plugin_vclipboard_64618cf8 from 'nuxt_plugin_vclipboard_64618cf8' // Source: ../plugins/v-clipboard.plugin (mode: 'all')
import nuxt_plugin_vtooltip_c2a1a5aa from 'nuxt_plugin_vtooltip_c2a1a5aa' // Source: ../plugins/v-tooltip.plugin (mode: 'all')
import nuxt_plugin_vueslickcarousel_125f198f from 'nuxt_plugin_vueslickcarousel_125f198f' // Source: ../plugins/vue-slick-carousel.plugin (mode: 'all')
import nuxt_plugin_vue2filters_b194345e from 'nuxt_plugin_vue2filters_b194345e' // Source: ../plugins/vue2-filters.plugin (mode: 'all')
import nuxt_plugin_vuescrollto_3553185c from 'nuxt_plugin_vuescrollto_3553185c' // Source: ../plugins/vue-scrollto.plugin (mode: 'client')
import nuxt_plugin_vueburgermenu_87dad032 from 'nuxt_plugin_vueburgermenu_87dad032' // Source: ../plugins/vue-burger-menu.plugin (mode: 'client')
import nuxt_plugin_vuejstogglebutton_1419ac3d from 'nuxt_plugin_vuejstogglebutton_1419ac3d' // Source: ../plugins/vue-js-toggle-button.plugin (mode: 'client')
import nuxt_plugin_polyfills_103db4d3 from 'nuxt_plugin_polyfills_103db4d3' // Source: ../plugins/polyfills.plugin (mode: 'client')
import nuxt_plugin_googletagmanager_09fc6085 from 'nuxt_plugin_googletagmanager_09fc6085' // Source: ../plugins/google-tag-manager.plugin (mode: 'client')
import nuxt_plugin_googleanalytics_1896b779 from 'nuxt_plugin_googleanalytics_1896b779' // Source: ../plugins/google-analytics.plugin (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"height=device-height, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=5.0"},{"name":"format-detection","content":"telephone=no"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"hid":"description","name":"description","content":"Qualidade nos produtos que sustentam a energia do nosso dia a dia."},{"hid":"og:title","property":"og:title","content":"Intelli - Referência em solução de energia no Brasil."},{"hid":"og:description","property":"og:description","content":"Qualidade nos produtos que sustentam a energia do nosso dia a dia."},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:site_name","property":"og:site_name","content":"Intelli - Referência em solução de energia no Brasil."},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fintelli.owinteractive.com\u002Fshare.png"},{"hid":"og:image:type","property":"og:image:type","content":"image\u002Fpng"},{"hid":"og:image:width","property":"og:image:width","content":"1200"},{"hid":"og:image:height","property":"og:image:height","content":"630"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto:wght@400;500;700;900&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Material+Icons|Material+Icons+Outlined"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_34482ef1 === 'function') {
    await nuxt_plugin_plugin_34482ef1(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_7a970fc6 === 'function') {
    await nuxt_plugin_gtm_7a970fc6(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_4cc42d2f === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_4cc42d2f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_554d9194 === 'function') {
    await nuxt_plugin_pluginutils_554d9194(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_239fec42 === 'function') {
    await nuxt_plugin_pluginrouting_239fec42(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_b3057420 === 'function') {
    await nuxt_plugin_pluginmain_b3057420(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_488c7b87 === 'function') {
    await nuxt_plugin_axios_488c7b87(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_0cfa93b2 === 'function') {
    await nuxt_plugin_helpers_0cfa93b2(app.context, inject)
  }

  if (typeof nuxt_plugin_services_7e39488d === 'function') {
    await nuxt_plugin_services_7e39488d(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_f6f05bbe === 'function') {
    await nuxt_plugin_axios_f6f05bbe(app.context, inject)
  }

  if (typeof nuxt_plugin_vmask_775c71e8 === 'function') {
    await nuxt_plugin_vmask_775c71e8(app.context, inject)
  }

  if (typeof nuxt_plugin_vclipboard_64618cf8 === 'function') {
    await nuxt_plugin_vclipboard_64618cf8(app.context, inject)
  }

  if (typeof nuxt_plugin_vtooltip_c2a1a5aa === 'function') {
    await nuxt_plugin_vtooltip_c2a1a5aa(app.context, inject)
  }

  if (typeof nuxt_plugin_vueslickcarousel_125f198f === 'function') {
    await nuxt_plugin_vueslickcarousel_125f198f(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2filters_b194345e === 'function') {
    await nuxt_plugin_vue2filters_b194345e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_3553185c === 'function') {
    await nuxt_plugin_vuescrollto_3553185c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueburgermenu_87dad032 === 'function') {
    await nuxt_plugin_vueburgermenu_87dad032(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejstogglebutton_1419ac3d === 'function') {
    await nuxt_plugin_vuejstogglebutton_1419ac3d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfills_103db4d3 === 'function') {
    await nuxt_plugin_polyfills_103db4d3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googletagmanager_09fc6085 === 'function') {
    await nuxt_plugin_googletagmanager_09fc6085(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_1896b779 === 'function') {
    await nuxt_plugin_googleanalytics_1896b779(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
